@if (useGenericCard) {
  <app-ds-generic-card
    [space]="subtext ? genericCardSpaces.NanoXXXS : genericCardSpaces.XXXS">
    <ng-container *ngTemplateOutlet="accordionContent"></ng-container>
  </app-ds-generic-card>
} @else {
  <ng-container *ngTemplateOutlet="accordionContent"></ng-container>
}

<ng-template #accordionContent>
  <div class="accordionDs__cont accordionDs__cont--{{type}}">
    <button class="accordionDs__header" aria-label="accordionDs--header" (click)="setShowContent()">
      <div class="accordionDs__header-text">
        @if (icon) {
          <div class="accordionDs__header-text-icon">
            <app-ds-icon
              [icon]="icon"
              [size]="iconSize"
              [color]="iconColor">
            </app-ds-icon>
          </div>
        }
        <div class="accordionDs__header-text-labels">
          <app-ds-typography
            [text]="text"
            [color]="fontColor"
            [fontFamily]="fontFamily.SemiBold"
            [size]="fontSize">
          </app-ds-typography>
          @if (subtext) {
            <app-ds-typography
              [text]="subtext"
              [color]="fontColor"
              [fontFamily]="fontFamily.Regular"
              [size]="fontSize">
            </app-ds-typography>
          }
        </div>
      </div>
      <div class="accordionDs__header-state">
        <app-ds-icon
          [icon]="stateIcon"
          [size]="16"
          [color]="iconColor">
        </app-ds-icon>
      </div>
    </button>
    <div class="accordionDs__content" [class.animated]="animated" [class.active]="showContent" [style.maxHeight.px]="maxHeight" #accordionDsContent>
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>